import { cn } from '@/lib/utils';
import './setup.css';

/** Three bouncing dots. Give a label when it stands for a status ("Writing a reply…"). */
export function TypingDots({ label, className }: { label?: string; className?: string }) {
  return (
    <span className={cn('sw-dots text-muted-foreground', className)} role={label ? 'status' : undefined}>
      <i />
      <i />
      <i />
      {label && <span className="sr-only">{label}</span>}
    </span>
  );
}
